export default [
  {
    title: 'Answer our simple questions',
    description:
      'Our online journey makes writing a will quick and easy. You can do it from the comfort of your own home in just 15 minutes.',
    illustration: 'cropped/blob-with-laptop',
  },
  {
    title: 'Get it approved by our specialists',
    description:
      'Our online will writing service includes specialist checking to make sure your wishes are clear – and it only takes up to 5 days.',
    illustration: 'cropped/experts',
  },
  {
    title: 'Print and sign your will',
    description:
      'After writing a will and getting it checked by our specialists, you need to print and sign it in front of two witnesses to make it legally binding. Download your will to print at home, or we can print it for you.',
    illustration: 'cropped/blob-signing-will',
  },
]
